// utils/formatting.js
export const formatPhoneNumber = (phoneNumber) => {
  const fullPhoneNumber =
    phoneNumber.first + phoneNumber.second + phoneNumber.third;

  if (phoneNumber.first === "02" && fullPhoneNumber.length === 9) {
    return fullPhoneNumber.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3");
  }
  if (phoneNumber.first.startsWith("01")) {
    return fullPhoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  }
  if (fullPhoneNumber.length === 10) {
    return fullPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  }
  return fullPhoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
};

export const getCurrentDateTime = () => {
  return new Date(new Date().getTime() + 9 * 60 * 60 * 1000) // 9시간 추가
    .toISOString() // ISO 형식의 문자열로 변환 (UTC 기준)
    .replace("T", " ") // T를 공백으로 대체하여 'YYYY-MM-DD HH:mm:ss' 포맷으로 변경
    .substring(0, 19); // 초까지 자르기
};
